<template>
  <BaseModal>
    <template v-slot:modalContent>
      <div class="row">
        <div class="col-md-8">
          <div class="form-group">
            <label><strong>Nome:</strong></label>
            <p id="id_nome_detalhe">{{ dado.nome }}</p>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label><strong>CRECI:</strong></label>
            <p id="id_creci_detalhe">{{ dado.creci }}</p>
          </div>
        </div>

        <div class="col-md-2">
          <div class="form-group text-right">
            <label><strong>Comissão (%):</strong></label>
            <p id="id_comissao_detalhe">{{ dado.comissao }}%</p>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label><strong>CEP:</strong></label>
            <p id="id_cep_detalhe">{{ dado.cep }}</p>
          </div>
        </div>
        <div class="col-md-8">
          <div class="form-group">
            <label><strong>Endereço:</strong></label>
            <p id="id_endereco_detalhe">{{ dado.endereco }}</p>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label><strong>Número:</strong></label>
            <p id="id_numero_detalhe">{{ dado.numero }}</p>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label><strong>Complemento:</strong></label>
            <p id="id_complemento_detalhe">{{ dado.complemento }}</p>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label><strong>Bairro:</strong></label>
            <p id="id_bairro_detalhe">{{ dado.bairro }}</p>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label><strong>Cidade:</strong></label>
            <p id="id_cidade_detalhe">{{ dado.cidade }}</p>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label><strong>UF:</strong></label>
            <p id="id_uf_detalhe">{{ dado.uf }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label><strong>Celular:</strong></label>
            <p id="id_telefone_detalhe">{{ dado.telefone }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label><strong>E-mail Pessoal:</strong></label>
            <p id="id_email_pessoal_detalhe">{{ dado.email_pessoal }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label><strong>E-mail Comercial:</strong></label>
            <p id="id_email_comercial_detalhe">{{ dado.email_comercial }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label><strong>E-mail Financeiro:</strong></label>
            <p id="id_email_financeiro_detalhe">{{ dado.email_financeiro }}</p>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label><strong>Chave Pix:</strong></label>
            <p id="id_chave_pix_detalhe">{{ dado.chave_pix }}</p>
          </div>
        </div>
        <div class="col-md-10">
          <div class="form-group">
            <label><strong>Observação:</strong></label>
            <p id="id_observacao_detalhe">{{ dado.observacao }}</p>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label><strong>Status:</strong></label>
            <p id="id_status_detalhe" v-html="dado.status"></p>
          </div>
        </div>
      </div>
      <div class="ibox-footer">
        <button class="btn btn-success font-bold" @click="$emit('fechar')">
          Fechar
        </button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "InformacoesCorretor",
  components: {
    BaseModal,
  },
  props: {
    itemKey: String,
  },
  data() {
    return {
      dado: 1,
      erro: null,
    };
  },
  emits: ['fechar'],
  methods: {
    async getDados() {
      const resultado = await apiRequest("GET", `${apiUrl.corretores.retrieveUpdateDestroy(this.itemKey)}?modo=info`);
      if (resultado.success) {
        this.dado = resultado.data;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
  },
  mounted() {
    this.getDados();
  },
}
</script>
